import clsx from 'clsx';
import React from 'react';
import { Animation, Icon, IconOfKind } from '@common/components';

type Props = {
  name: string;
  hasChildren: boolean;
  isExpanded: boolean;
  isActive: boolean;
  onClick: () => void;
  iconOfKind?: IconOfKind;
  isHorizontalCollapsed?: boolean;
};

export function VerticalMenuItemHeader({
  onClick,
  iconOfKind,
  name,
  hasChildren,
  isExpanded,
  isActive,
  isHorizontalCollapsed,
}: Props) {
  return (
    <>
      <button className="vertical-menu-item-header" onClick={onClick}>
        {iconOfKind && (
          <span className="icon-container">
            <Icon {...iconOfKind} />
          </span>
        )}
        {!isHorizontalCollapsed && (
          <>
            <span className="item-label">{name}</span>
            {hasChildren && (
              <span className="icon-container icon-chevron show-on-hover">
                <Animation kind="rotate-left" active={isExpanded}>
                  <Icon icon="chevronDown" kind="light" />
                </Animation>
              </span>
            )}
            {isActive && (
              <span
                className={clsx('icon-container', 'icon-chevron', {
                  'hide-on-hover': hasChildren,
                })}
              >
                <Icon icon="chevronRight" kind="light" />
              </span>
            )}
          </>
        )}
      </button>
      <style jsx>{`
        .vertical-menu-item-header {
          padding: 8px 16px;
          position: relative;
          outline: none;
        }

        .icon-container {
          width: 20px;
          margin-right: 8px;
          text-align: center;
          display: inline-block;
        }

        .icon-chevron {
          position: absolute;
          right: 0;
          top: 10px;
        }

        .show-on-hover,
        .vertical-menu-item-header:hover .hide-on-hover {
          display: none;
        }

        .hide-on-hover,
        .vertical-menu-item-header:hover .show-on-hover {
          display: inline-block;
        }

        button.vertical-menu-item-header {
          cursor: pointer;
          margin: 0;
          border: none;
          display: block;
          width: 100%;
          text-align: left;
          background-color: transparent;
        }
        .icon-container.icon-chevron :global(.wk-animation) {
          height: 16px;
        }
      `}</style>
    </>
  );
}
